import { useEffect, useState } from "react";
import { SubStepsScreenV2Props } from "../StepByStep/Index";
import { useOnboarding } from "../../../hooks/useOnboarding";
import { UserProgressScreensProps } from "../../../contexts/OnboardingContext";
import "./styles.css";

type SubStepV2Props = {
  subStep?: SubStepsScreenV2Props;
  sectionNumb: number;
  screenNumb: number;
  isSummary?: boolean;
};

export function SubStepV2({ subStep, screenNumb, sectionNumb, isSummary = false }: SubStepV2Props) {
  const { userProgress, setShowScreen } = useOnboarding();
  const [state, setState] = useState<UserProgressScreensProps>("nothing");

  useEffect(() => {
    const section = userProgress.find((p) => p.section === sectionNumb);
    if (section?.screens?.[screenNumb]) setState(section.screens[screenNumb].type);
  }, [userProgress, screenNumb, sectionNumb]);

  const canNavigate = state !== "nothing";

  return (
    <section className="substep-v2">
      <div className="substep-v2__line" />
      <button
        className={`substep-v2__button substep-v2__button--${state} ${isSummary ? "substep-v2__button--summary" : ""}`}
        type="button"
        onClick={() => setShowScreen(userProgress, sectionNumb, screenNumb)}
        disabled={!canNavigate}
      >
        <span className={`substep-v2__label substep-v2__label--${state}`}>{subStep?.name}</span>
        <span className={`substep-v2__dot substep-v2__dot--${state} ${isSummary ? "substep-v2__dot--summary" : ""}`} />
      </button>
    </section>
  );
}
